import './videoTelematics.css';
import {Outlet} from "react-router-dom";

const VideoTelematics = () => {
    return (
        <>
            <Outlet/>
        </>
    )
}
export default VideoTelematics;
